import React from "react";
import { toTitleCase } from "../utils/functions";

export interface OutfitItemCardProps {
  id: string;
  style: string;
  category: string;
  colors: string[];
  imageUrl?: string | null;
  description?: string | null;
  onClick?: () => void;
}

const OutfitItemCard: React.FC<OutfitItemCardProps> = ({
  id,
  style,
  category,
  colors,
  imageUrl,
  description,
  onClick,
}) => {
  return (
    <div
      className="group relative bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm rounded-xl shadow-sm hover:shadow-xl transition-all duration-500 cursor-pointer flex flex-col overflow-hidden border border-gray-200/50 dark:border-gray-700/50 hover:border-gray-400/60 dark:hover:border-gray-500/60 hover:scale-105"
      onClick={onClick}
      data-testid={`outfit-item-card-${id}`}
    >
      {imageUrl ? (
        <div className="relative overflow-hidden">
          <img
            src={imageUrl}
            alt={style}
            className="w-full h-48 object-contain bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-800 dark:to-gray-900 transition-transform duration-500 group-hover:scale-110"
            loading="lazy"
            onError={(e) => {
              e.currentTarget.classList.add("opacity-0");
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        </div>
      ) : (
        <div className="relative w-full h-48 flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-800 dark:to-gray-900 overflow-hidden">
          <div className="text-gray-400 dark:text-gray-500 font-light tracking-wider uppercase text-xs">
            No Image
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        </div>
      )}
      <div className="p-6 flex-1 flex flex-col gap-3">
        <h3 className="text-lg font-light text-gray-900 dark:text-gray-100 tracking-wider uppercase truncate transition-colors duration-300 group-hover:text-gray-700 dark:group-hover:text-white">
          {toTitleCase(style)}
        </h3>
        <div className="flex flex-col gap-1">
          <p className="text-xs font-light text-gray-600 dark:text-gray-400 tracking-wider uppercase">
            {toTitleCase(category)}
          </p>
          <p className="text-xs font-light text-gray-500 dark:text-gray-500 tracking-wide">
            {Array.isArray(colors) && colors.length > 0
              ? colors.map(color => toTitleCase(color)).join(" • ")
              : "No colors specified"}
          </p>
          {description ? (
            <p className="text-sm font-light text-gray-700 dark:text-gray-300 tracking-wide line-clamp-2" data-testid="outfit-item-description">
              {description}
            </p>
          ) : null}
        </div>
        <div className="mt-auto pt-2">
          <div className="h-px bg-gradient-to-r from-transparent via-gray-300 dark:via-gray-600 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        </div>
      </div>
    </div>
  );
};

export default OutfitItemCard;
